"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../../common/constants/states");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var moment_1 = __importDefault(require("moment"));
var AdminInstructorsEditContactInfoController = /** @class */ (function () {
    function AdminInstructorsEditContactInfoController($state, UsersModel, FlashService, instructor) {
        this.editPassword = false;
        this.states = states_1.States;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.$state = $state;
        this.instructor = instructor;
        this.submit = this.submit.bind(this);
    }
    AdminInstructorsEditContactInfoController.prototype.submit = function (isValid) {
        var _this = this;
        this.submitted = true;
        if (isValid) {
            var payload = (0, cloneDeep_1.default)(this.instructor);
            if (payload.usermeta.license) {
                payload.usermeta.license.expiration_date = (0, moment_1.default)(payload.usermeta.license.expiration_date, 'MMDDYYYY').format('YYYY-MM-DD');
            }
            else {
                delete payload.usermeta.license;
            }
            if (payload.usermeta.phone) {
                payload.usermeta.phone = payload.usermeta.phone.toString();
            }
            // @ts-ignore
            delete payload.zones;
            // @ts-ignore
            delete payload.locations;
            // @ts-ignore
            delete payload.zoneparts;
            // @ts-ignore
            delete payload.sectors;
            this.UsersModel.updateInstructor(payload).then(function (response) {
                _this.FlashService.setMessage({
                    'type': 'success',
                    'message': response.message
                });
                _this.$state.go('drivecoach.admin.instructors.view', { 'instructorId': response.instructor.id });
                _this.submitted = false;
            }).catch(function (Error) {
                _this.submitted = false;
            });
        }
        else {
            this.submitted = false;
            this.FlashService.setMessage({ 'type': 'error', 'message': 'Please fill the form.' });
        }
    };
    return AdminInstructorsEditContactInfoController;
}());
AdminInstructorsEditContactInfoController.$inject = ['$state', 'UsersModel', 'FlashService', 'instructor'];
exports.default = AdminInstructorsEditContactInfoController;
